import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative px-0 py-10 lg:p-10 w-full min-h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "block lg:hidden h-8 mw-40 mb-6",
  src: "/media/logos/logo-full-dark.svg",
  alt: "Logo"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-4xl leading-10 font-extrabold mb-6 lg:mb-10" }, "Company information", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl leading-7 font-medium mb-6" }, "Select or create the company you originate loans for", -1)
const _hoisted_5 = { class: "md:flex flex-wrap" }
const _hoisted_6 = { class: "w-full md:w-1/2 pr-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "company",
  class: "block text-sm font-medium text-gray-700"
}, " Company ", -1)
const _hoisted_8 = {
  type: "button",
  class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
}
const _hoisted_9 = {
  key: 0,
  class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
  id: "options",
  role: "listbox"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex items-center justify-between truncate" }
const _hoisted_12 = {
  key: 0,
  class: "w-full mt-4 md:mt-0 md:w-1/2 pr-4"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "website",
  class: "block text-sm font-medium text-gray-700"
}, " Website ", -1)
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = {
  key: 0,
  class: "rounded-md bg-yellow-50 p-4 mt-2"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-yellow-700" }, " Please use a valid website url ")
], -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!
  const _component_ArrowNarrowRightIcon = _resolveComponent("ArrowNarrowRightIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      class: "block p-6 rounded-md shadow-sm bg-white mb-4 max-w-5xl",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
    }, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", {
            class: "mt-2 relative",
            ref: "target",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
          }, [
            _withDirectives(_createElementVNode("input", {
              id: "company",
              type: "text",
              class: "w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-12 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm",
              role: "combobox",
              "aria-controls": "options",
              "aria-expanded": "false",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company) = $event)),
              placeholder: "Janover",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, _ctx.company]
            ]),
            _createElementVNode("button", _hoisted_8, [
              _createVNode(_component_SelectorIcon, { class: "w-4 h-4" })
            ]),
            (_ctx.isOpened)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, ({ name, id }) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: id,
                      class: "relative cursor-pointer select-none py-2 px-3 text-gray-900 hover:bg-sky hover:text-white",
                      role: "option",
                      tabindex: "-1",
                      onClick: ($event: any) => (_ctx.handleSelect({ name, id }))
                    }, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(name), 1)
                    ], 8, _hoisted_10))
                  }), 128)),
                  (!Object.values(_ctx.filteredOptions).length)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: "relative select-none py-2 pl-3 pr-9 text-gray-900 cursor-pointer",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSelect({ name: _ctx.company, id: null })))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.company), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]),
        (_ctx.collectedData.name && !_ctx.collectedData.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "website",
                  id: "website",
                  class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md border h-10 px-3 text-sm max-w-full", { 'border-red-600': !_ctx.isValidWebsite }]),
                  placeholder: "https://janover.co",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.collectedData.lenderUri) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.collectedData.lenderUri]
                ])
              ]),
              (!_ctx.isValidWebsite)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["h-10 bg-sky text-white rounded-md w-24 mt-6 flex justify-center items-center", { 'pointer-events-none opacity-50': !_ctx.isValid }]),
        type: "submit"
      }, [
        _createTextVNode(" Next "),
        _createVNode(_component_ArrowNarrowRightIcon, { class: "w-4 h-4 ml-2" })
      ], 2)
    ], 32)
  ]))
}